import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const catalogHealthViewAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.catalogHealth],
  permissions: [Permission.CatalogHealthView],
}
